import { render } from "./WebsiteAnalyticsPage.vue?vue&type=template&id=b0225df4"
import script from "./WebsiteAnalyticsPage.vue?vue&type=script&lang=js"
export * from "./WebsiteAnalyticsPage.vue?vue&type=script&lang=js"

import "./WebsiteAnalyticsPage.vue?vue&type=style&index=0&id=b0225df4&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__